import {useMemo} from "react";

import {useTranslation} from "react-i18next";

export const useUserRole = () => {
  const {t} = useTranslation();

  const USER_ROLE_OPTIONS = useMemo(
    () => [
      {id: 0, name: t("role.admin"), value: "Admin"},
      {id: 1, name: t("role.manager"), value: "Manager"},
      {id: 2, name: t("role.rep"), value: "Representative"},
    ],
    [t],
  );

  return {
    USER_ROLE_OPTIONS,
  };
};
